import request from 'yeself-common/utils/RequestUtils';

import EnvironmentConfiguration from 'yeself-client-common/EnvironmentConfiguration';

export const fetchThemesListIds = (appId) =>
    request.get(`${EnvironmentConfiguration.API_MANAGE_SLUG}/manage/applications/${appId}/themes`);

export const fetchTheme = (appId, themeId) =>
    request.get(
        `${EnvironmentConfiguration.API_MANAGE_SLUG}/manage/applications/${appId}/themes/${themeId}`,
        { header: { 'X-Editor-Url': EnvironmentConfiguration.EDITOR_URL } }
    );

export const cloneTheme = (appId, themeId, themeNameOveride) =>
    request.put(
        `${EnvironmentConfiguration.API_MANAGE_SLUG}/manage/applications/${appId}/themes/${themeId}/_clone`,
        { name: themeNameOveride },
        { header: { 'X-Editor-Url': EnvironmentConfiguration.EDITOR_URL } }
    );

export const fetchThemeSchema = (appId, themeId) =>
    request.get(
        `${EnvironmentConfiguration.API_MANAGE_SLUG}/manage/applications/${appId}/themes/${themeId}/schema`,
        { header: { 'X-Editor-Url': EnvironmentConfiguration.EDITOR_URL } }
    );

export const editTheme = (appId, themeId, payload) =>
    request.put(
        `${EnvironmentConfiguration.API_MANAGE_SLUG}/manage/applications/${appId}/themes/${themeId}/schema`,
        payload
    );

export const deleteTheme = (appId, themeId) =>
    request.del(
        `${EnvironmentConfiguration.API_MANAGE_SLUG}/manage/applications/${appId}/themes/${themeId}`
    );
